import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, ScrollView } from "react-native"


import tw from '../../styles/tailwind';
import Text from '../../components/Text';
import api from '../../utils/api';
import Input from '../../components/Forms/Input';
import Button from '../../components/Forms/Button';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { actions } from '../../store/Reducers/auth';
import PasswordInput from '../../components/Forms/PasswordInput';


export default function SignUpForm({ invitation, onSignup }) {
  const { control, handleSubmit, setError, formState: { errors }, reset } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sending, setSending] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    if (invitation){
      reset({
        name: invitation.resident.name ,
        phone_number: invitation.resident.user?.phone_number || "" ,
        email: invitation.resident.user?.email || "" ,
      })
    }
  }, []);


  const doSignup = (formData) => {
    const data = {
      ...formData,
      invitation_id: invitation.uuid,
    }

    setIsSubmitting(true)
    setErrorMessage()

    api.post(`auth/invitation/register`, data)
      .then(({ data }) => {
        dispatch(actions.login(data.user, data.access_token))
        onSignup()
      })
      .catch(({ response }) => {
        // console.log("Error en el registro: ", response)
        setIsSubmitting(false)

        if (response.data?.message) {
          setErrorMessage(response.data?.message)
        }

        //TODO:  ABSTRAER! esto se puede estar ocupando en varios lados más
        const { errors } = response.data

        Object.keys(errors).map(i => {
          setError(i, { message: errors[i][0] });
        })
      })
  }


  return (
    <View style={tw``}>

      {/* Nombre */}
      <View style={tw`mb-0`}>
        <Text style={tw`text-gray-500`}>Tu Nombre</Text>
      
        <Input
          name="name"
          editable={false}
          control={control}
          rules={{ required: "Nombre requerido"}}
          style={{ input: tw`text-gray-600 opacity-70` }}
          // placeholderTextColor={tw.color(`gray-400`)}
          // style={tw`bg-white w-50% self-center text-xl text-center py-4 rounded-2xl border border-gray-300`}

        />
      </View>
  

      {/* Teléfono */}
      <View style={tw`mb-0`}>
        <Text style={tw`text-gray-500`}>Teléfono</Text>
      
      
        <Input
          name="phone_number"
          control={control}
          rules={{ required: "El teléfono es requerido", pattern: { value: /\d{10}/, message: "El teléfono debe tener 10 dígitos" } }}
          keyboardType={"phone-pad"}
          // label="Teléfono"
          placeholder="10 dígitos"
          maxLength={10}
          style={{ input: tw`text-gray-700` }}
        />
      </View>
  
  
      {/* email */}
      <View style={tw`mb-0`}>
        <Text style={tw`text-gray-500`}>Correo electrónico</Text>
      
        <Input
          name="email"
          control={control}
          autoCapitalize={"none"}
          rules={{ required: "El correo electrónico es requerido", pattern: { value: /^\S+@\S+$/, message: "Correo no válido" } }}
          keyboardType={"email-address"}
          style={{ input: tw`text-gray-700` }}

          // label="Correo Electrónico"
          // style={{ container: tw`mt-3`, label: tw`text-gray-300 bg-transparent`, input: tw`py-2` }}
        />
      </View>
  

      {/* Contraseña */}
      <View style={tw`mb-0`}>
        <Text style={tw`text-gray-500`}>Crea una contraseña</Text>
      
        <PasswordInput
          name={'password'}
          control={control}
          rules={{ required: "Contraseña requerida" }} 
          style={{ input: tw`text-gray-700 rounded-full`, subcontainer: tw`bg-gray-200` }}
        />
      </View>

      


      {/* <CheckButton
        style={{ label: tw`text-gray-200`, container: tw`border-[#999]` }}
        label={"Acepto los términos y condiciones y el aviso de privacidad"}
        control={control} name={"tos_accepted"}
      /> */}

      {
        errorMessage &&
          <Text style={tw`text-red-400 text-center my-4`}>{errorMessage}</Text>

      }

      {/*  */}
      <Button
        // style={tw.style(`mt-6 py-4 items-center rounded-md  px-20 `, { opacity: isSubmitting ? 0.5 : 1 })}
        onPress={(handleSubmit(doSignup))}
        disabled={isSubmitting}
        label="Terminar mi registro"
        labelColor={"#fff"}
        style={{ container: tw`mt-4 rounded-full` }}
      />

    </View>
  );
}